import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import ConversationsList from '../Components/ConversationsList';
import Conversation from '../Conversation';
import ConversationProvider from '../ConversationProvider';
import CreateConversation from '../CreateConversation';
import ConversationsListProvider from '../ConversationsListProvider';
import ConversationsNotificationsProvider from 'utils/ConversationsNotificationsProvider';

export default function FloatingMessagesRoutes() {
  const navigate = useNavigate();
  const handleBack = () => navigate('..');

  return (
    <ConversationsListProvider>
      <Routes>
        <Route index element={<ConversationsList width="w-full" />} />
        <Route
          path="compose"
          element={<CreateConversation onBack={handleBack} />}
        />
        <Route
          path=":conversationId"
          element={
            <ConversationsNotificationsProvider>
              <ConversationProvider>
                <Conversation onBack={handleBack} />
              </ConversationProvider>
            </ConversationsNotificationsProvider>
          }
        />
        <Route path="*" element={<Navigate replace to="." />} />
      </Routes>
    </ConversationsListProvider>
  );
}
